// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-list-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.survey-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e5e7eb;
}

[data-theme="dark"] .survey-list-header {
  border-bottom-color: #374151;
}

.survey-list-header h1 {
  color: #333;
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  transition: color 0.3s ease;
}

[data-theme="dark"] .survey-list-header h1 {
  color: #f0f0f0;
}

.page-description {
  color: #6b7280;
  font-size: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0;
}

[data-theme="dark"] .page-description {
  color: #9ca3af;
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background: #f5f5f5;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

[data-theme="dark"] .empty-state {
  background: #2a2a2a;
}

.empty-state p {
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  transition: color 0.3s ease;
}

[data-theme="dark"] .empty-state p {
  color: #b0b0b0;
}

.survey-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.survey-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.2s, box-shadow 0.2s, background-color 0.3s ease;
}

[data-theme="dark"] .survey-card {
  background: #1e1e1e;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.survey-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

[data-theme="dark"] .survey-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.4);
}

.survey-card h3 {
  color: #333;
  margin-bottom: 0.5rem;
  transition: color 0.3s ease;
}

[data-theme="dark"] .survey-card h3 {
  color: #f0f0f0;
}

.survey-card p {
  color: #666;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
}

[data-theme="dark"] .survey-card p {
  color: #b0b0b0;
}

.survey-meta {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
  transition: border-color 0.3s ease;
}

[data-theme="dark"] .survey-meta {
  border-bottom-color: #424242;
}

.survey-meta span {
  color: #888;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

[data-theme="dark"] .survey-meta span {
  color: #9ca3af;
}

.survey-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}

.btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover {
  background: #0056b3;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #545b62;
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover {
  background: #c82333;
}

.btn-sm {
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
}

.btn-success {
  background: #28a745;
  color: white;
}

.btn-success:hover {
  background: #218838;
}

/* URL 복사 버튼 애니메이션 */
.survey-actions .btn-success {
  animation: successPulse 0.5s ease;
}

@keyframes successPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* 상태 배지 스타일 */
.status {
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
}

.status.published {
  background: #d4edda;
  color: #155724;
}

[data-theme="dark"] .status.published {
  background: rgba(25, 135, 84, 0.2);
  color: #75b798;
}

.status.draft {
  background: #fff3cd;
  color: #856404;
}

[data-theme="dark"] .status.draft {
  background: rgba(255, 193, 7, 0.2);
  color: #ffcd39;
}

/* 로딩 및 에러 상태 */
.loading-state, .error-state {
  text-align: center;
  padding: 3rem;
  background: #f8f9fa;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

[data-theme="dark"] .loading-state,
[data-theme="dark"] .error-state {
  background: #2a2a2a;
}

.loading-state p, .error-state p {
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
}

[data-theme="dark"] .loading-state p,
[data-theme="dark"] .error-state p {
  color: #b0b0b0;
}

/* 아이콘 버튼 스타일 */
.btn-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  font-size: 16px;
  border-radius: 4px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

[data-theme="dark"] .btn-icon {
  background: #2a2a2a;
  border-color: #424242;
  color: #e0e0e0;
}

.btn-icon:hover {
  background: #e9ecef;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

[data-theme="dark"] .btn-icon:hover {
  background: #3a3a3a;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.btn-icon.btn-danger {
  background: #dc3545;
  border-color: #dc3545;
  color: white;
}

.btn-icon.btn-danger:hover {
  background: #c82333;
  border-color: #bd2130;
}

/* 비활성화된 편집 버튼 스타일 */
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn:disabled:hover {
  background: initial;
  transform: none;
}`, "",{"version":3,"sources":["webpack://./src/components/SurveyList.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".survey-list-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.survey-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n[data-theme=\"dark\"] .survey-list-header {\n  border-bottom-color: #374151;\n}\n\n.survey-list-header h1 {\n  color: #333;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0;\n  transition: color 0.3s ease;\n}\n\n[data-theme=\"dark\"] .survey-list-header h1 {\n  color: #f0f0f0;\n}\n\n.page-description {\n  color: #6b7280;\n  font-size: 1rem;\n  margin-top: 0.5rem;\n  margin-bottom: 0;\n}\n\n[data-theme=\"dark\"] .page-description {\n  color: #9ca3af;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: #f5f5f5;\n  border-radius: 8px;\n  transition: background-color 0.3s ease;\n}\n\n[data-theme=\"dark\"] .empty-state {\n  background: #2a2a2a;\n}\n\n.empty-state p {\n  color: #666;\n  font-size: 1.1rem;\n  margin-bottom: 1.5rem;\n  transition: color 0.3s ease;\n}\n\n[data-theme=\"dark\"] .empty-state p {\n  color: #b0b0b0;\n}\n\n.survey-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.survey-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  transition: transform 0.2s, box-shadow 0.2s, background-color 0.3s ease;\n}\n\n[data-theme=\"dark\"] .survey-card {\n  background: #1e1e1e;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.3);\n}\n\n.survey-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n[data-theme=\"dark\"] .survey-card:hover {\n  box-shadow: 0 4px 8px rgba(0,0,0,0.4);\n}\n\n.survey-card h3 {\n  color: #333;\n  margin-bottom: 0.5rem;\n  transition: color 0.3s ease;\n}\n\n[data-theme=\"dark\"] .survey-card h3 {\n  color: #f0f0f0;\n}\n\n.survey-card p {\n  color: #666;\n  margin-bottom: 1rem;\n  transition: color 0.3s ease;\n}\n\n[data-theme=\"dark\"] .survey-card p {\n  color: #b0b0b0;\n}\n\n.survey-meta {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #eee;\n  transition: border-color 0.3s ease;\n}\n\n[data-theme=\"dark\"] .survey-meta {\n  border-bottom-color: #424242;\n}\n\n.survey-meta span {\n  color: #888;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n}\n\n[data-theme=\"dark\"] .survey-meta span {\n  color: #9ca3af;\n}\n\n.survey-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.btn {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.2s;\n}\n\n.btn-primary {\n  background: #007bff;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #0056b3;\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #545b62;\n}\n\n.btn-danger {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover {\n  background: #c82333;\n}\n\n.btn-sm {\n  padding: 0.25rem 0.75rem;\n  font-size: 0.875rem;\n}\n\n.btn-success {\n  background: #28a745;\n  color: white;\n}\n\n.btn-success:hover {\n  background: #218838;\n}\n\n/* URL 복사 버튼 애니메이션 */\n.survey-actions .btn-success {\n  animation: successPulse 0.5s ease;\n}\n\n@keyframes successPulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* 상태 배지 스타일 */\n.status {\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.status.published {\n  background: #d4edda;\n  color: #155724;\n}\n\n[data-theme=\"dark\"] .status.published {\n  background: rgba(25, 135, 84, 0.2);\n  color: #75b798;\n}\n\n.status.draft {\n  background: #fff3cd;\n  color: #856404;\n}\n\n[data-theme=\"dark\"] .status.draft {\n  background: rgba(255, 193, 7, 0.2);\n  color: #ffcd39;\n}\n\n/* 로딩 및 에러 상태 */\n.loading-state, .error-state {\n  text-align: center;\n  padding: 3rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  transition: background-color 0.3s ease;\n}\n\n[data-theme=\"dark\"] .loading-state,\n[data-theme=\"dark\"] .error-state {\n  background: #2a2a2a;\n}\n\n.loading-state p, .error-state p {\n  color: #666;\n  font-size: 1.1rem;\n  margin-bottom: 1rem;\n  transition: color 0.3s ease;\n}\n\n[data-theme=\"dark\"] .loading-state p,\n[data-theme=\"dark\"] .error-state p {\n  color: #b0b0b0;\n}\n\n/* 아이콘 버튼 스타일 */\n.btn-icon {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  font-size: 16px;\n  border-radius: 4px;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  color: #495057;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n[data-theme=\"dark\"] .btn-icon {\n  background: #2a2a2a;\n  border-color: #424242;\n  color: #e0e0e0;\n}\n\n.btn-icon:hover {\n  background: #e9ecef;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n[data-theme=\"dark\"] .btn-icon:hover {\n  background: #3a3a3a;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.3);\n}\n\n.btn-icon.btn-danger {\n  background: #dc3545;\n  border-color: #dc3545;\n  color: white;\n}\n\n.btn-icon.btn-danger:hover {\n  background: #c82333;\n  border-color: #bd2130;\n}\n\n/* 비활성화된 편집 버튼 스타일 */\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn:disabled:hover {\n  background: initial;\n  transform: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
